import Vue from 'vue'
import {login, getInfo, logout} from '@/api/login'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {welcome} from '@/utils/util'
import {sysInfo} from '@/config'

const user = {
  state: {
    userId: '',
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    isAdmin: false
  },
  getters: {
    userId: state => state.userId,
    isAdmin: state => state.isAdmin,
    userInfo: state => state.info
  },
  mutations: {
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, {name, welcome}) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_ISADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    }
  },

  actions: {
    // 登录
    Login({commit}, params) {
      return new Promise((resolve, reject) => {
        if (sysInfo.ifDebug) {
          Vue.ls.set(ACCESS_TOKEN, '123456789', 7 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', '123456789')
          commit('SET_INFO', {
            'dataPermMap': null,
            'departmentid': 701,
            'email': null,
            'id': 1,
            'lastname': 'zhenmkj',
            'loginIp': '127.0.0.1',
            'loginid': 'zhenmkj',
            'mobile': null,
            'roleCodeList': ['admin'],
            'sex': '0',
            'status': 0,
            'subcompanyid': 21,
            'telephone': null,
            'workcode': null
          })
          commit('SET_USERID', 1)
          resolve('loginSuccess')
        } else {
          login(params).then(res => {
            if (res.status === 0 && res.data) {
              const result = res.data
              Vue.ls.set(ACCESS_TOKEN, result.accessToken, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.accessToken)
              commit('SET_INFO', result.zmUser)
              commit('SET_USERID', result.zmUser.id)
              resolve('loginSuccess')
            }
          }).catch(error => {
            reject(error)
          })
        }
      })
    },

    // 获取用户信息
    GetInfo({commit}) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data

          if (result.role && result.role.permissions.length > 0) {
            const role = result.role
            role.permissions = result.role.permissions
            role.permissions.map(per => {
              if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
                const action = per.actionEntitySet.map(action => {
                  if (action.defaultCheck) {
                    return action.action
                  }
                })
                per.actionList = action
              } else {
                per.actionList = []
              }
            })
            role.permissionList = role.permissions.map(permission => {
              return permission.permissionId
            })
            commit('SET_ROLES', result.role)
          } else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }
          commit('SET_INFO', result)
          commit('SET_USERID', result.id)
          commit('SET_AVATAR', result.avatar)
          commit('SET_ISADMIN', result.admin)

          if (sysInfo.ifDebug) {
            commit('SET_INFO', {
              'dataPermMap': null,
              'departmentid': 701,
              'email': null,
              'id': 1,
              'lastname': 'zhenmkj',
              'loginIp': '127.0.0.1',
              'loginid': 'zhenmkj',
              'mobile': null,
              'roleCodeList': ['admin'],
              'sex': '0',
              'status': 0,
              'subcompanyid': 21,
              'telephone': null,
              'workcode': null
            })
            commit('SET_USERID', 1)
          }

          // commit('SET_USERID', result.id)
          // commit('SET_NAME', { name: result.name, welcome: welcome() })
          // commit('SET_AVATAR', result.avatar)
          // commit('SET_ISADMIN', result.admin)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({commit, state}) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        Vue.ls.remove(ACCESS_TOKEN)

        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  }
}

export default user
